import { css } from '@repo/pandacss/styled-system/css';
import { Badge } from '../Logo/Badge';
import { SafeLinkWithFallback } from '../SafeLinkWithFallback';
import { RatingTooltip } from './components/RatingTooltip';
import { StarIcon } from './components/StarIcon';

type ShortHorizontalLayoutProps = {
  hideNwLogo?: boolean;
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
};

export const ShortHorizontalLayout = ({
  hideNwLogo = false,
  reviewLink,
  starRating,
  starRatingTooltip,
}: ShortHorizontalLayoutProps) => {
  return (
    <div
      data-testid="rating-component"
      className={css({
        display: 'flex',
        columnGap: '2',
        rowGap: '2',
        alignItems: 'center',
      })}
    >
      {!hideNwLogo && (
        <Badge
          className={css({
            height: '3.5',
            width: '3.5',
          })}
          size={14}
        />
      )}
      {starRating && starRating > 0 ? (
        <>
          <div
            className={css({
              display: 'flex',
              alignItems: 'center',
              columnGap: '0.5',
              rowGap: '0.5',
            })}
          >
            <span
              className={css({
                fontSize: 'sm',
                fontWeight: 'bold',
                textStyle: 'textBold',
              })}
            >
              <SafeLinkWithFallback href={reviewLink} target="_blank">
                {starRating.toFixed(1)}
              </SafeLinkWithFallback>
            </span>
            <StarIcon color="#008254" iconSize={15} />
          </div>
          {starRatingTooltip && (
            <div
              className={css({
                '& button': {
                  display: 'flex',
                },
              })}
            >
              <RatingTooltip
                starRatingTooltip={starRatingTooltip}
                tooltipColor="neutral.dark"
                tooltipSize="16px"
              />
            </div>
          )}
        </>
      ) : (
        <span
          className={css({
            textStyle: 'textSmall',
          })}
        >
          Not yet rated
        </span>
      )}
    </div>
  );
};
